import { Box, styled } from '@mui/material';

// Solo espaciado: la tipografía del cuerpo la gobierna proseSx (ContentRenderer);
// el fontSize que se sobreescribía aquí aplastaba la jerarquía de títulos.
const StyledNewsBodyContainer = styled(Box)(({ theme }) => ({
  marginTop: '15px',
  '& > *:first-of-type': {
    marginTop: 0
  },
  [theme.breakpoints.up('sm')]: {
    marginTop: '25px'
  },
  [theme.breakpoints.up('lg')]: {
    marginTop: '40px'
  }
}));

export default StyledNewsBodyContainer;
